module.exports = __webpack_public_path__ + "img/arrow-down.7ca0304e.svg";